import type React from 'react';

interface LogoBlackIconProps extends React.SVGProps<SVGSVGElement> {
  size?: number;
}

export function LogoBlackIcon({ size = 24, ...props }: LogoBlackIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g id="Native Teams fill">
        <g id="Vector">
          <path
            d="M10.5547 3.03974C10.5547 2.54618 10.4076 2.05766 10.1337 1.64468C9.85986 1.23171 9.4744 0.909383 9.01794 0.718004C8.56655 0.531661 8.06444 0.486335 7.57755 0.582024C7.09573 0.68275 6.64941 0.924492 6.30453 1.27703C6.04079 1.53892 5.84299 1.85621 5.7162 2.20371C5.5894 2.55122 5.54376 2.9239 5.57926 3.29659C5.61476 3.66424 5.73141 4.02181 5.92414 4.3391C6.11687 4.65639 6.37046 4.92835 6.67984 5.13483C7.01965 5.36147 7.41018 5.50248 7.81592 5.54277C8.22167 5.58306 8.63248 5.52263 9.01287 5.3665C9.31717 5.23556 9.59105 5.04922 9.81928 4.80747C10.291 4.3391 10.5547 3.69949 10.5547 3.03974Z"
            fill="currentColor"
          />
          <path
            d="M2.59703 7.02341L7.03486 14.7592C7.59276 15.7513 8.53611 15.7513 9.09908 14.7592L11.0467 11.3546C8.27238 12.0345 4.16929 9.76315 2.59703 7.02341Z"
            fill="currentColor"
          />
          <path
            d="M14.0949 3.0397C13.1465 3.0397 11.9901 3.89587 11.5235 4.94342C11.5235 4.94342 10.4432 7.37595 8.06454 7.37595C7.24798 7.37595 6.45678 7.07881 5.83802 6.53992C6.61908 7.49178 9.28177 9.55163 13.2175 7.57236L14.7796 4.85277C15.3527 3.85054 15.0383 3.0397 14.0949 3.0397Z"
            fill="currentColor"
          />
          <path
            d="M5.83802 6.53498C5.32577 6.09178 4.90481 5.54786 4.61064 4.93847C4.14404 3.89092 2.98767 3.03475 2.04431 3.03475C1.09081 3.03979 0.781433 3.85063 1.35455 4.84782L2.59714 7.01846C4.1694 9.7582 8.27248 12.0346 11.0569 11.3497L13.2226 7.57245C9.2767 9.55172 6.61907 7.49187 5.83802 6.53498Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  );
}
